import { createSelector } from "reselect";

const createSliceSelector = namespace =>
  createSelector(
    state => state.anonymous[namespace],
    slice => ({ [namespace]: slice }),
  );

export const signupSliceSelector = createSliceSelector("signup");
